import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiveawayConfigQuery = createQueryHook(GiveawayConfigApiClient.getGiveawayConfig, {
  queryKey: ['giveawayConfig'],
})
